<template>
  <div class="content-header">
    <div class="content-search" style="width: auto">
        {{txt}}
    </div>
    <nav class="nav">
        <slot />
    </nav>
    </div>
</template>

<script>
export default {
    props:{
      txt: {
        type: String,
        default: () => null,
      },
    }
}
</script>

<style>

</style>